import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import { Form, Formik } from 'formik';
import {
  ShopHeroWidgetFields,
  ShopHeroWidgetFormFields,
} from 'components/consumer-page-widgets/shop-hero-widget/ShopHeroWidgetFormFields';
import { Widgets } from '@tock/shared/types/widget';
import {
  getBaseFormFieldsInitialValues,
  useCreateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';

import React, { FunctionComponent } from 'react';

interface CreateShopHeroWidgetFormProps {
  onCompleteOrCancel(): void;
}

export const CreateShopHeroWidgetForm: FunctionComponent<
  React.PropsWithChildren<CreateShopHeroWidgetFormProps>
> = ({ onCompleteOrCancel }) => {
  const createNamedConfig = useCreateNamedConfigurations();

  const handleSubmit = ({
    leftImageAlt,
    leftImageUrl,
    rightImageAlt,
    rightImageUrl,
    bodyText,
    linkText,
    linkHref,
    name,
  }: ShopHeroWidgetFields) => {
    return createNamedConfig({
      name: name,
      widgetType: Widgets.WidgetCreatorWidgetType,
      shopHeroWidgetConfig: {
        shopHeroImage: [
          { imageAlt: leftImageAlt, imageUrl: leftImageUrl },
          { imageAlt: rightImageAlt, imageUrl: rightImageUrl },
        ],
        bodyText,
        linkText,
        linkHref,
      },
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Create widget</Typography>
      <Formik<ShopHeroWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues(),
          leftImageAlt: '',
          leftImageUrl: '',
          rightImageAlt: '',
          rightImageUrl: '',
          bodyText: '',
          linkText: '',
          linkHref: '',
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <ShopHeroWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button variant="outlined" type="button" onClick={onCompleteOrCancel}>
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
